export default "/img/KP.a4ef723671143a909ceeed864037f25d.png";